import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from '@/components/ui/button';
import { QuotationPage } from './types';

interface PageSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  pages: any[];
  title?: string;
  onPageSelect?: (targetPageId: string) => void;
  onSelectPage?: (pageId: string) => void;
  currentPageId?: string; // ID of the current page to exclude
}

export function PageSelectionModal({ 
  isOpen,
  onClose,
  pages,
  onSelectPage,
  onPageSelect,
  currentPageId,
  title = "Selecionar página"
}: PageSelectionModalProps) {
  // Log para debugging
  console.log('[PageSelectionModal] Recebendo props:', {
    isOpen,
    pagesReceived: Boolean(pages),
    pagesLength: pages?.length,
    currentPageId,
    hasOnSelectPage: Boolean(onSelectPage),
    hasOnPageSelect: Boolean(onPageSelect),
    pagesData: pages?.map(p => ({ id: p.id, title: p.title })),
  });
  
  // Filter out only the current page if currentPageId is provided
  const availablePages = Array.isArray(pages) && currentPageId 
    ? pages.filter(page => page.id !== currentPageId)
    : Array.isArray(pages) ? pages : [];
  
  console.log('[PageSelectionModal] Páginas disponíveis após filtragem:', {
    availablePagesLength: availablePages?.length,
    availablePages: availablePages?.map(p => ({ id: p.id, title: p.title })),
    filtragem: currentPageId ? `Excluindo página ${currentPageId}` : 'Sem exclusão de página atual'
  });
    
  if (!isOpen || !availablePages || availablePages.length === 0) {
    console.log('[PageSelectionModal] Não renderizando o modal:', {
      motivo: !isOpen ? 'isOpen é false' : !availablePages ? 'availablePages é null/undefined' : 'availablePages está vazio'
    });
    return null;
  }

  // Função de callback de seleção de página que suporta ambas as props
  const handleSelectPage = (pageId: string) => {
    if (onPageSelect) {
      onPageSelect(pageId);
    } else if (onSelectPage) {
      onSelectPage(pageId);
    }
    onClose();
  };
  
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        
        <div className="py-4 max-h-[300px] overflow-y-auto">
          {availablePages.length === 0 ? (
            <div className="text-center text-gray-500 py-4">
              Não há páginas disponíveis para mover este item.
            </div>
          ) : (
            <div className="space-y-2">
              {availablePages.map((page) => (
                <Button
                  key={page.id}
                  variant="outline"
                  className="w-full justify-start text-left h-auto py-3"
                  onClick={() => handleSelectPage(page.id)}
                >
                  {page.title || 'Página sem título'}
                </Button>
              ))}
            </div>
          )}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
} 